export const VIN_WONDER_PRICE_LIST_ACTION = "VIN_WONDER_PRICE_LIST_ACTION";
export const VIN_WONDER_PRICE_LIST_SUCCESS = "VIN_WONDER_PRICE_LIST_SUCCESS";
export const VIN_WONDER_PRICE_LIST_FAIL = "VIN_WONDER_PRICE_LIST_FAIL";
export const VIN_WONDER_PRICE_DELETE_TRANSLATE_SUCCESS = "VIN_WONDER_PRICE_DELETE_TRANSLATE_SUCCESS";

export const VIN_WONDER_PRICE_DETAIL_ACTION = "VIN_WONDER_PRICE_DETAIL_ACTION";
export const VIN_WONDER_PRICE_DETAIL_DELETE_ACTION = "VIN_WONDER_PRICE_DETAIL_DELETE_ACTION";
export const VIN_WONDER_PRICE_DETAIL_SUCCESS = "VIN_WONDER_PRICE_DETAIL_SUCCESS";
export const VIN_WONDER_PRICE_DETAIL_FAIL = "VIN_WONDER_PRICE_DETAIL_FAIL"

export const VIN_WONDER_PRICE_DETAIL_UPDATE_ACTION = "VIN_WONDER_PRICE_DETAIL_UPDATE_ACTION";
export const VIN_WONDER_PRICE_DETAIL_CREATE_ACTION = "VIN_WONDER_PRICE_DETAIL_CREATE_ACTION";
export const VIN_WONDER_PRICE_FAIL = "VIN_WONDER_PRICE_FAIL";

